import imageSpalle from '../../assets/trattamenti/spalla.jpg';
import BackgroundImgBlur from '../../components/BackgroundImgBlur';


export default function Spalla() {
    const spalleContent = <>
    <div data-aos="fade-zoom-in" data-aos-duration="1000" className={`text-lg mt-10 mb-16 text-white`} > 
        <ul className='text-left'>
            <li className="mb-5 pb-3 border-b-2 border-[#65806E] mt-8">
               <b> Patologie Specifiche (es. Lussazioni, Fratture, Lesioni di Cuffia):</b> <br /> Terapia manuale, esercizio terapeutico, tecar terapia, laser terapia, onde d’urto focali, fase di ritorno all'attività.
            </li>
            <li className="mb-5 pb-3 border-b-2 border-[#65806E] mt-8">
                <b>Patologie Aspecifiche (Tendinopatie, Conflitto Sub-acromiale):</b> <br /> Terapia manuale, esercizio terapeutico, tecar terapia, laser terapia, onde d’urto focali.
            </li>
        </ul>
    </div>
    </>
    return <>
        <BackgroundImgBlur src={imageSpalle} title={'SPALLE'} content={spalleContent} hscreen={true}/>
    </>
}